import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { PushNotificationsService, WebPushSubscription } from "./push-notifications.service";
import { YomaDateFormatPipe } from "../../pipes/yoma-date-format.pipe";

@Component({
  selector: 'push-notifications',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NzFormModule, NzInputModule, NzSelectModule, NzButtonModule, NzSpinModule, YomaDateFormatPipe],
  templateUrl: './push-notifications.component.html',
  styleUrl: './push-notifications.component.scss'
})
export class PushNotificationsComponent implements OnInit {
  pushNotificationsService = inject(PushNotificationsService);
  notification = inject(NzNotificationService);
  fb = inject(FormBuilder);

  subscriptions: WebPushSubscription[] = [];
  loading = false;
  sending = false;

  form = this.fb.group({
    subscription: this.fb.control<WebPushSubscription | null>(null, Validators.required),
    title: ['', Validators.required],
    message: ['', Validators.required],
    link: ['/'],
  });

  ngOnInit(): void {
    this.loading = true;
    this.pushNotificationsService.getSubscriptions().subscribe({
      next: res => {
        this.subscriptions = res;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.notification.error('Error', 'Could not load push subscriptions');
      }
    });
  }

  label(s: WebPushSubscription): string {
    const platform = s.device?.['platform'] ?? 'unknown';
    return `${s.user_name} · ${platform}`;
  }

  send(): void {
    const { subscription, title, message, link } = this.form.getRawValue();
    if (this.form.invalid || !subscription) {
      this.form.markAllAsTouched();
      return;
    }
    this.sending = true;
    this.pushNotificationsService.sendNotification({
      tenant_id: subscription.tenant_id,
      user_id: subscription.user_id,
      endpoint: subscription.endpoint,
      title: title!,
      message: message!,
      link: link ?? '',
    }).subscribe({
      next: () => {
        this.sending = false;
        this.notification.success('Sent', 'Test push notification sent');
      },
      error: err => {
        this.sending = false;
        this.notification.error('Error', err?.error?.detail ?? 'Sending failed');
      }
    });
  }
}
